import GLOBALS from '../config/globals';

const MODE_CONFIG = {
    [GLOBALS.AUTO_MANAGER.SAFE.key]: GLOBALS.AUTO_MANAGER.SAFE,
    [GLOBALS.AUTO_MANAGER.NORMAL.key]: GLOBALS.AUTO_MANAGER.NORMAL,
    [GLOBALS.AUTO_MANAGER.CRAZY.key]: GLOBALS.AUTO_MANAGER.CRAZY,
};

/** Cycle: null → safe → normal → crazy → null */
export const nextManagerMode = (currentMode) => {
    const modes = GLOBALS.AUTO_MANAGER.MODES;
    if (!currentMode) return modes[0];
    const idx = modes.indexOf(currentMode);
    return idx === modes.length - 1 ? null : modes[idx + 1];
};

export const getAutoManagerConfig = (mode) => MODE_CONFIG[mode] || null;
